import React, { useState } from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import {
  STORAGE_CONSTANT,
  URLS,
  WORKER_GROUP_URL,
  ESTATE_FETCH_URL,

} from "configs/constants";
import { getAssignedModule } from "utils";
import { ZONE_FETCH_URL } from "configs/constants";
import { REGION_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";

const initialValues = {
  // status: "",
  name: "",
  group_id: "",
  estate: "",
  company: "",
  zone: "",
  region: "",
  active: true,
};

const WorkerGroupForm = () => {
  const [disableZone, setDisableZone] = useState(true);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const formFields = [
    {
      type: "input",
      name: "group_id",
      label: "Code",
      required: true,
    },
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
      required: true,


    },    
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      disabled:disableZone,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      required:true,
      optionsDependsOn: "company",

    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      required:true,
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      disabled:disableEstate,
      optionsDependsOn: "region",
      required:true,
      paginated: false,
      isPaginationEnabled: false,
     },
    {
      type: "renderonly",
      label: "Supervisor",
      name:"supervisor",
      key: "supervisor_name",
      
    },
  ];
const validationSchema = Yup.object({
  company: Yup.string().required("Company is required").typeError("Company is required"),
  zone: Yup.string().required("Zone is required").typeError("Zone is required"),
  region: Yup.string()
    .required("Region is required")
    .typeError("Region is required"),
  
  group_id: Yup.string()
  .required("Code is required")
  .typeError("Invalid code")
  .nullable(),
  name: Yup.string()
  .required("Name is required")
  .typeError("Invalid Name")
  .nullable(),
  estate: Yup.string()
  .required("Estate is required")
  .typeError("Invalid Estate")
  .nullable(),


 
});
  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0 || e.label == "N/A") {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "switch",
      name: "active",
      label: "Active?",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
    });
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={WORKER_GROUP_URL}
      listRoute={URLS.WORKER_GROUP}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Worker Group"
      validationSchema={validationSchema}
    />
  );
};

export default WorkerGroupForm;
